'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hammer = require('./Hammer');

var _Hammer2 = _interopRequireDefault(_Hammer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Hammer2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-hammerjs/lib/index.js
// module id = 2543
// module chunks = 0